





















import { Component, Vue } from "vue-property-decorator";
import { Col, Row, Tag } from 'vant';
import { ErrorCode, ErrorInfo, RequestState } from "@/network/http";
import { getQueryParam } from "@/utils/index";
import { FaqDetail } from "@/data/local/faq";
import PageLoad from "@/components/PageLoad.vue";

Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);

@Component({
    components: {
        "v-page-load": PageLoad
    }
})
export default class FaqDetailPage extends Vue {
    status: RequestState = RequestState.WAIT;
    errorMsg: string = "";
    id: number = 0;
    faqDetail: FaqDetail | null = null;

    mounted() {
        let id = parseInt(this.$route.params.id);
        this.id = id;

        this.fetchList(id);
    }

    get showLoadingPage(): boolean {
        return this.status !== RequestState.SUCCESS;
    }

    get cat(): string {
        if (this.faqDetail.cat === 1) {
            return "公积金贷款";
        } else if (this.faqDetail.cat === 2) {
            return "公积金提取";
        } else if (this.faqDetail.cat === 3) {
            return "公积金缴存";
        } else {
            return "其他"
        }
    }

    onRefresh(ret: boolean) {
        this.fetchList(this.id);
    }

    fetchList(id: number): void {
        this.status = RequestState.WAIT;
        let lThis:any = this;
        lThis.$http.getFaqDetail(id, (errorInfo: ErrorInfo, data: FaqDetail | null) => {
            if (errorInfo.errorCode !== ErrorCode.SUCCESS) {
                this.status = RequestState.FAIL;
                return;
            }
            this.status = RequestState.SUCCESS;
            this.faqDetail = data;
        });
    }
}
